import React from 'react'
import TangramLink from '@ntuctech/devex-tangram/Link'
import Typography from '@ntuctech/devex-tangram/Typography'
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained'
import { LINKS } from '../../../../lib/navigation'
import { Radio } from '../../../Input/Input'
import CheckboxWrapper from './CheckboxWrapper'
import { ErrorText, Field } from './elements'

const MembershipSelection = ({
  state: {
    activePackages,
    errors,
    isLegalAge,
    isSubscribingPromotions,
    selectedPackage,
  },
  dispatch,
  isRenewingMembership,
  tncUrl,
}) => {
  const nextStep = 'SUBMIT_MEMBERSHIP_FORM'

  return (
    <>
      <Typography variant="h5">Select membership commitment</Typography>
      {activePackages.map(item => (
        <Field
          data-testid="package-option"
          onClick={() => dispatch({ type: 'SET_PACKAGE_OPTION', id: item.id })}
          key={item.id}
        >
          <Radio
            name="package"
            checked={selectedPackage === item.id}
            value={item.id}
            label={item.title}
            onChange={() => null}
          />
        </Field>
      ))}
      {errors.includes('selectedPackage') && (
        <ErrorText>Please select your yearly plan</ErrorText>
      )}
      {!isRenewingMembership && (
        <Field>
          <CheckboxWrapper
            onClick={() => dispatch({ type: 'TOGGLE_LEGAL_AGE' })}
            name="above-18"
            checked={isLegalAge}
            label="I confirm that I am above the age of 18 and able to buy alcoholic beverages by law"
            data-testid="above18-option"
          />
          {errors.includes('isLegalAge') && (
            <ErrorText>Please confirm your age</ErrorText>
          )}
        </Field>
      )}
      <Field smalltext>
        <CheckboxWrapper
          name="receive-promo"
          data-testid="promo-checkbox"
          onClick={() => dispatch({ type: 'TOGGLE_PROMOTION_SUBSCRIPTION' })}
          checked={isSubscribingPromotions}
          label="I would like to receive promotions from Just Wine Club via email and SMS"
        />
      </Field>
      <Field borderless smalltext>
        By clicking &apos;{isRenewingMembership ? 'Renew' : 'Continue'}&apos;,
        you have read &amp; agreed to our{' '}
        <TangramLink
          size="l"
          href={tncUrl}
          target="_blank"
          rel="noreferrer noopener"
        >
          Terms & Conditions
        </TangramLink>{' '}
        and{' '}
        <TangramLink
          size="l"
          href={LINKS.privacyNotice.url}
          target="_blank"
          rel="noreferrer noopener"
        >
          {LINKS.privacyNotice.label}
        </TangramLink>
      </Field>
      <ButtonContained
        size="l"
        data-testid="renewal-button"
        fullWidth
        type="button"
        onClick={() => dispatch({ type: nextStep })}
      >
        {isRenewingMembership ? 'Renew' : 'Continue'}
      </ButtonContained>
    </>
  )
}

export default MembershipSelection
